"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spacer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const computeStyledMargins_1 = require("components/general/utility/computeStyledMargins");
const Spacer = styled_components_1.default.div `
  ${computeStyledMargins_1.computeStyledMargins}
`;
exports.Spacer = Spacer;
